<template>
	<div class="form-group m-b-0">
		<label :for="filterName" data-testid="dateSelectLabel">{{ placeholder }} <span class="input-kbd-help text-gray-5 nano">(YYYY-MM-DD)</span></label>
		<div class="date-nav" data-testid="dateSelectFilter">
			<button class="btn btn-input datepicker-trigger" tabindex="-1">
				<span class="flex-container">
					<span class="btn-icon-text">{{ currentDateDisplay }}</span><span class="ico-calendar"></span>
				</span>
			</button>
			<DatePicker :id="filterName" type="text" @touchstart.native="testTouch" @dp-change="updateDate" v-model="currentDate" :config="datepickerOptions"></DatePicker>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import DatePicker from 'vue-bootstrap-datetimepicker';
import { momentProvider } from '@/services/clock.service';
import moment from 'moment';

export default defineComponent({
	name: 'DateSelect',
	components: {
		DatePicker
	},
	props: {
		filterName: {
			type: String,
			required: true
		},
		placeholder: {
			type: String,
			required: true
		},
		initialDate: {
			type: String,
			required: true
		},
		externalData: {
			type: Object,
			default: () => {}
		},
		daysMin: {
			type: Number,
			default: 0
		},
		daysMax: {
			type: Number,
			default: 90
		}
	},
	data() {
		return {
			currentDate: null,
			datepickerType: 'text',
			datepickerOptions: {
				format: 'YYYY-MM-DD',
				widgetPositioning: {
					horizontal: 'left',
					vertical: 'bottom'
				},
				minDate: momentProvider().add(this.daysMin, 'days').format('YYYY-MM-DD'),
				maxDate: momentProvider().add(this.daysMax, 'days').format('YYYY-MM-DD'),
				ignoreReadonly: true
			}
		};
	},
	computed: {
		currentDateDisplay: function() {
			return moment(this.currentDate, 'YYYY-MM-DD').format('dddd, MMM D');
		}
	},
	mounted() {
		this.currentDate = this.initialDate;
	},
	methods: {
		testTouch(event) {
			const el = $(event.target);
			if (el.attr('type') !== 'date') {
				event.preventDefault();
				el.attr('type', 'date');
				el.addClass('datepicker-hide');
				el.focus();
			}
		},
		updateDate(e) {
			if (e.oldDate !== null) { // Don't emit event for initial date set (on mounted)
				this.$emit('change', { value: this.currentDate }, this.externalData);
			}
		},
		setValue(value) {
			this.currentDate = value;
		},
		getValue() {
			return this.currentDate;
		}
	}
});
</script>
